// Ordenação dos profissionais nas colunas da Agenda do Dia (esquerda para a
// direita) e na lista de gestão. A ordem desejada é guardada como uma lista
// de ids na chave `ordem_profissionais` de `configuracoes` (key-value por
// tenant), em JSON — mesmo mecanismo usado para `ordem_categorias`
// (ver `src/lib/categorias.js`).
//
// `ordenarProfissionais` aplica essa ordem a uma lista de profissionais:
// os que estão na ordem guardada aparecem primeiro (pela posição definida);
// os restantes (ex.: profissionais novos ainda não ordenados) vão para o
// fim, por ordem alfabética do nome. Assim nada "desaparece" e o
// comportamento antigo (alfabético) mantém-se enquanto não houver ordem
// definida.

export function parseOrdemProfissionais(valor) {
  if (!valor) return []
  try {
    const arr = JSON.parse(valor)
    return Array.isArray(arr) ? arr.filter(x => typeof x === 'string') : []
  } catch {
    return []
  }
}

export function ordenarProfissionais(profissionais, ordem) {
  const ordemArr = Array.isArray(ordem) ? ordem : parseOrdemProfissionais(ordem)
  const indice = new Map(ordemArr.map((id, i) => [id, i]))
  return [...profissionais].sort((a, b) => {
    const ia = indice.has(a.id) ? indice.get(a.id) : Infinity
    const ib = indice.has(b.id) ? indice.get(b.id) : Infinity
    if (ia !== ib) return ia - ib
    return a.nome.localeCompare(b.nome, 'pt')
  })
}
